<template>
  <div class="p-3">
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>

    <div v-else>
      <!-- <div class="d-flex justify-content-between align-items-center my-2">
        <h5 class="font-weight-bolder mb-0">
          <i class="fas fa-book text-success mr-2"></i>
          {{ group.name || 'Course Group' }}
          <b-badge variant="info" class="ml-1" style="font-size: 0.75rem;">Courses {{ totalOfferings }}</b-badge>
        </h5>        
      </div> -->

      <div v-if="!displayGroups.length" class="text-muted small py-2">
        No courses in this group.
      </div>

      <div v-else class="col-8 mx-auto bg-white p-2 mt-2">
        <div>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0 font-weight-bold">
              <i class="fas fa-book text-success mr-2"></i> Courses &amp; Offerings {{ totalOfferings ? `(${totalOfferings})` : '' }}
            </h5>
            <!-- <b-button variant="primary" size="sm" @click="openGenerateModal">
              <i class="fas fa-plus mr-1"></i> Generate Courses
            </b-button> -->
          </div>
        </div>
        <div class="">
        <table class="table table-bordered table-striped">
          <thead class="thead-dark">
            <tr>
              <th style="width:50px">Sl.No</th>
              <th style="width:130px">Course Code</th>
              <th>Course Name</th>
              <th>Course Offering</th>
              <th style="width:110px">Class Code</th>
              <th style="width:110px">Academic Year</th>
              <th>Program</th>
            </tr>
          </thead>
          <tbody
            v-for="(grp, index) in displayGroups"
            :key="grp.code"
            :class="grp.shaded ? 'group-shaded' : ''"
          >
            <tr>
              <td :rowspan="grp.courses.length" class="align-middle text-center">{{ index + 1 }}</td>              
              <td :rowspan="grp.courses.length" class="align-middle font-weight-bold">
                {{ grp.code }}
                <i
                  v-if="grp.nameMismatch"
                  class="fas fa-exclamation-triangle text-warning ml-1"
                  v-b-tooltip.hover
                  :title="'Source names: ' + grp.sourceNames.join(', ')"
                  style="cursor:pointer"
                ></i>
              </td>
              <td :rowspan="grp.courses.length" class="align-middle font-weight-bold">
                {{ grp.courses[0].name }}
                <i
                  v-if="grp.nameMismatch"
                  class="fas fa-exclamation-triangle text-warning ml-1"
                  v-b-tooltip.hover
                  :title="'Source names: ' + grp.sourceNames.join(', ')"
                  style="cursor:pointer"
                ></i>
              </td>                      
              <td :rowspan="grp.courses.length" class="align-middle">
                <div v-for="(c, ci) in grp.courses" :key="ci">
                  {{ c.name }}
                  <hr v-if="ci < grp.courses.length - 1" class="my-1" />
                </div>
              </td> 
              <td>{{ grp.courses[0].class_code }}</td>
              <td>{{ grp.courses[0].academic_year+'-'+grp.courses[0].academic_semester}}</td>
              <td>{{ grp.courses[0].program_name }}</td>
            </tr>
            <tr v-for="course in grp.courses.slice(1)" :key="course.id">
              <td>{{ course.class_code }}</td>
              <td>{{ course.academic_year+'-'+course.academic_semester }}</td>
              <td>{{ course.program_name }}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseGroupDetail",

  props: {
    groupId: { type: Number, required: true },
  },

  data() {
    return {
      fetchData: false,
      group: {},
    };
  },

  computed: {
    displayGroups() {
      const groupedCourses = this.group.grouped_courses || [];
      let shadeToggle = false;
      // a grouped course whose courses were all deleted has nothing to show, and every row reads courses[0]
      return groupedCourses.filter(gc => (gc.courses || []).length).map(gc => {
        shadeToggle = !shadeToggle;
        return {
          code:        gc.code,
          nameMismatch: gc.name_mismatch_flag,
          sourceNames:  gc.source_names || [],
          shaded:       shadeToggle,
          courses: (gc.courses || []).map(c => ({
            id:           c.id,
            name:         c.name,
            class_code:   c.usersubgroup ? c.usersubgroup.code : null,
            academic_year: c.academic_year,
            academic_semester: c.academic_semester,
            program_name: c.usersubgroup && c.usersubgroup.usergroup
              ? c.usersubgroup.usergroup.name
              : null,
          })),
        };
      });
    },

    totalOfferings() {
      return this.group.grouped_courses.length;
    },
  },

  async mounted() {
    await this.fetchGroupDetail();
  },

  methods: {
    async fetchGroupDetail() {
      this.fetchData = true;
      try {
        const res = await this.$axios.get(
          `${this.$store.getters.getAPIKey.mainAPI}/course-groups/${this.groupId}`
        );
        this.group = res.data.data || {};
      } catch {
        this.$toasted.error("Failed to load course group details.", { duration: 3000 });
      } finally {
        this.fetchData = false;
      }
    },
  },
};
</script>



<style>
.group-shaded { background-color: #f8f9fa; }
</style>
